<div class="header-navbar" style="min-height: min-content !important">
  <div class="navbar-container p-0">
    <li
      ngbDropdown
      class="nav-item dropdown dropdown-language list-unstyled"
      [placement]="isNotMargin ? 'top-left' : 'bottom-left'"
      container="body"
    >
      <a class="nav-link dropdown-toggle" id="dropdown-flag" ngbDropdownToggle>
        <i
          class="flag-icon flag-icon-{{
            languageOptions[_translateService.currentLang].flag
          }}"
        ></i
        ><span class="selected-language">{{
          languageOptions[_translateService.currentLang].title
        }}</span></a
      >
      <div
        ngbDropdownMenu
        aria-labelledby="dropdown-flag"
        [style.margin]="isNotMargin ? '0' : null"
      >
        <a
          *ngFor="let lang of _translateService.getLangs()"
          ngbDropdownItem
          (click)="setLanguage(lang)"
        >
          <i class="flag-icon flag-icon-{{ languageOptions[lang].flag }}"></i>
          {{ languageOptions[lang].title }}
        </a>
      </div>
    </li>
  </div>
</div>
